import { render } from "./np-collapsible-item.vue?vue&type=template&id=9db38834&scoped=true"
import script from "./np-collapsible-item.vue?vue&type=script&lang=js"
export * from "./np-collapsible-item.vue?vue&type=script&lang=js"

import "./np-collapsible-item.vue?vue&type=style&index=0&id=9db38834&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db38834"]])

export default __exports__